import style from "./Swiper.module.css"
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

// Import Swiper styles
//import 'swiper/css';
import SwiperCore, {
  Autoplay
} from 'swiper';

import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
SwiperCore.use([Autoplay]);

export default function Main() {
  return (
    <Swiper className={style.swiper}
      spaceBetween={50}
      slidesPerView={1}
      autoplay={{
        "delay": 5500,
        "disableOnInteraction": false
      }}
      onSlideChange={() => console.log('slide change')}
      onSwiper={(swiper) => console.log(swiper)}
    >
      <SwiperSlide><div className={style.swiperc1}> </div></SwiperSlide>
      <SwiperSlide><div className={style.swiperc2}> </div></SwiperSlide>
      <SwiperSlide><div className={style.swiperc3}> </div></SwiperSlide>



    </Swiper>
  );
};